import { useSelector, useDispatch } from 'react-redux'
import { itemsFetchData } from '../../redux/items'
import { parseSubjectsFromUrl } from '../../SearchUtils'

function ChangeCurrency() {
  const currentFilters = useSelector(
    (state) => state.items.currentFilters || {}
  )
  const currency = useSelector((state) => state.items.currency)

  const dispatch = useDispatch()
  const fetchData = (filter, options = {}) => {
    dispatch(itemsFetchData({ filters: filter, options }))
  }

  const handleChangeCurrency = (currency) => {
    const newFilters = {
      popstate: 0,
      subjects: parseSubjectsFromUrl(),
      ...currentFilters,
    }

    App.Request.post('/local_settings/set_regional_preferences', {
      currency,
    }).then(({ data }) => fetchData(newFilters, { data }))
  }

  const currencyIcon = (_currency) => {
    if (_currency === 'EUR') return 'euro-sign'
    if (_currency === 'USD') return 'dollar-sign'
    if (_currency === 'GBP') return 'pound-sign'

    return ''
  }

  return (
    <div className="dropdown sort-by me-3" style={{ height: '45px' }}>
      <button
        type="button"
        className="btn btn-sm text-primary dropdown-toggle"
        id="dropdown-filter-change-currency"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i className={`far fa-${currencyIcon(currency)} fa-fw`} /> {currency}
      </button>
      <div
        className="dropdown-menu w-100"
        aria-labelledby="dropdown-filter-change-currency"
      >
        {App.State.availableCurrencies.map((_currency, i) => (
          <div key={`currency-${_currency.id}`}>
            <button
              type="button"
              className="dropdown-item"
              onClick={() => handleChangeCurrency(_currency.value)}
            >
              <i className={`far fa-${currencyIcon(_currency.value)} fa-fw`} />{' '}
              {_currency.value}
            </button>
            {i !== App.State.availableCurrencies.length - 1 && (
              <div className="dropdown-divider" />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ChangeCurrency
